import {
  email,
  emptyString
} from './index'
export default (inputEmail, password) => {
  if (!emptyString(password, 'Password', 'Password')) {
    return false
  }
  if (!email(inputEmail, 'Email', 'Email')) {
    return false
  }
  return true
}
